<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-title
          class="headline body-1 blue-grey darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-delete</v-icon>Eliminar produto
        </v-card-title>
        <v-card-text class="pa-8">
          <v-card-text>
            Tem certeza que pretende eliminar ?
          </v-card-text>
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-card-actions>
              <v-btn
                color="error lighten-2"
                text
                block
                @click="deleteProduct"
                :disabled="!valid"
                :loading="loading"
              >
                Eliminar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "../../../../main";

export default {
  name: "OpenDeleteProduct",
  data: () => ({
    index: Number,
    elem: Number,
    dialog: false,
    valid: true,
    value: true,
    loading: false,
    wat: ""
  }),
  methods: {
    deleteProduct() {
      if (this.$refs.form.validate() && this.index) {
        const payload = {
          productUUID: this.index
        };
        this.$store.dispatch("deleteProduct", payload);
        this.sleep(3000).then(() => {
          if (this.$store.getters.getEventDeleteProduct) {
            let elemFinish = "sys" + this.elem;
            let obj = document.getElementById(elemFinish);
            obj.remove();
            this.$store.dispatch("clearEventDeleteProduct");
          }
        });
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  created() {
    const self = this;
    eventBus.$on("openDeleteProduct", function(value) {
      self.dialog = value.dialog;
      self.index = value.index;
      self.elem = value.obj;
    });
  }
};
</script>

<style scoped></style>
